'use client';

import { useEffect } from 'react';
import Button from '@/components/ui/button/Button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Comprehensive error logging for diagnostics
    console.error('=== Root Error Boundary ===');
    console.error('Error:', error);
    console.error('Message:', error.message);
    console.error('Stack:', error.stack);
    console.error('Digest:', error.digest);
    console.error('User Agent:', navigator.userAgent);
    console.error('URL:', window.location.href);
    console.error('Timestamp:', new Date().toISOString());

    // Send to New Relic (if available)
    if (typeof window !== 'undefined' && (window as any).newrelic) {
      // Report error with full context
      (window as any).newrelic.noticeError(error, {
        digest: error.digest,
        boundary: 'root',
        userAgent: navigator.userAgent,
        url: window.location.href,
      });

      // Send custom event for easier alerting
      (window as any).newrelic.addPageAction('ErrorBoundaryActivated', {
        boundary: 'root',
        errorMessage: error.message,
        errorName: error.name,
        url: window.location.href,
        digest: error.digest,
      });
    }
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold mb-4">Something went wrong</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          {error.message || 'An unexpected error occurred'}
        </p>
        {process.env.NODE_ENV === 'development' && (
          <details className="mt-4 text-left bg-gray-100 dark:bg-gray-800 p-4 rounded">
            <summary className="cursor-pointer font-semibold mb-2">
              Error Details (Development Only)
            </summary>
            <pre className="text-xs overflow-auto whitespace-pre-wrap">
              {error.stack}
            </pre>
          </details>
        )}
        <Button onClick={reset} className="mt-4">Try again</Button>
      </div>
    </div>
  );
}
